import { G } from './icons.tsx';
import { useT } from '../i18n/I18n.tsx';
import type { DeliveryState } from './types.js';

/**
 * Delivery indicator.
 *
 * The familiar mark, driven by state the product genuinely has:
 *
 *   pending — queued in this browser, not yet acknowledged
 *   sent    — the server acknowledged and stored the ciphertext
 *   failed  — the send was refused
 *
 * There is deliberately no read receipt. This build has no delivery or read
 * confirmation between participants, and drawing a second tick would assert
 * something the system cannot know. Adding one would also be a privacy decision
 * in its own right, not a visual one.
 */
export function Ticks({ state }: { state: DeliveryState }) {
  const t = useT();
  if (state === 'pending') {
    return (
      <span className="ticks" title={t('message.sending')}>
        <G n="clock" size={14} label={t('message.sending')} />
      </span>
    );
  }
  if (state === 'failed') {
    return (
      <span className="ticks ticks--failed" title={t('message.failed')}>
        <G n="warning" size={14} label={t('message.failed')} />
      </span>
    );
  }
  return (
    <span className="ticks" title={t('message.sent')}>
      <G n="check" size={15} label={t('message.sent')} />
    </span>
  );
}
